export default "__VITE_ASSET__C72INvem__"